export let CONST_IS_MULTILINGUAL = {};
CONST_IS_MULTILINGUAL.isMul = false;